import { useQuery } from 'react-query';
import { customClamshellService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useFetchTemplateById = (templateId: string | undefined | null) => {
  return useQuery(
    `${ServerStateKeysEnum.clamshellTemplates}/${templateId}`,
    () => {
      return customClamshellService.getCustomTemplateById(templateId);
    },
    {
      staleTime: Infinity,
      enabled: !!templateId,
    }
  );
};
